'use client'
import React, { useMemo, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp, FaExchangeAlt } from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";
import listaMenu from "./listaMenu";
//import { Link } from 'react-router-dom' 
import classNames from "classnames";
import { userInfo } from "../services/authHandlers";
import { useInfo } from "../context/infoContext";
import AppCard from "./appCard";

function cloneMenuProvider(source) {
  return source.map(group => ({
    ...group,
    items: group.items.map(item =>
      item.items ? { ...item, items: [...item.items] } : { ...item }
    )
  }));
}

export default function AppMenu(props) {
  const { providerInfo } = useInfo();
  const { menuProvider } = listaMenu;
  const [activeIndex, setActiveIndex] = useState(null)
  const changeTabRef = useRef(false)
  const prevTabRef = useRef(null)
  const path = useLocation()


  const pccInfo = providerInfo?.parametros?.pcc_info;
  const hasEnabledField = pccInfo && Object.prototype.hasOwnProperty.call(pccInfo, "pcc_proposta_enabled");

  const showPropostas = hasEnabledField && pccInfo.pcc_proposta_enabled !== null;

  const menuProviderModel = useMemo(() => {
    const cloned = cloneMenuProvider(menuProvider);
    const rootItems = cloned?.[0]?.items ?? [];
    // Evita duplicar em re-render
    const jaTemPropostas = rootItems.some(i => i?.to === "/dashboard/propostas");
    // Insere após "Negocia Direto" se existir; caso contrário, no final
    if (showPropostas && !jaTemPropostas) {
      const itemPropostas = { label: "Propostas", icon: <FaExchangeAlt />, to: "/dashboard/propostas" };
      // Insere após "Negocia Direto" se existir; caso contrário, no final
      const idxNegociaDireto = rootItems.findIndex(i => i?.label === "Negocia Direto");
      rootItems.splice(idxNegociaDireto >= 0 ? idxNegociaDireto + 1 : rootItems.length, 0, itemPropostas);
    }

    return cloned;
  }, [menuProvider, showPropostas]);

  // useEffect(()=>{
  //   setActiveItem(path)
  // },[activeIndex])


  function onMenuClick(index) {
    if (activeIndex === index) {
      setActiveIndex(null)
      prevTabRef.current = activeIndex
      changeTabRef.current = true
    }
    else {
      if (index.length === 3)
        changeTabRef.current = false
      else {
        prevTabRef.current = activeIndex
        setActiveIndex(index)
        changeTabRef.current = true
      }
    }
  }

  function MenuComponent({ props, index }) {
    //console.log(index,activeIndex)
    const prev_active = index === prevTabRef.current
    const active_route = path.pathname === props.to
    const active = index === activeIndex

    if (props.items)
      return (
        <div className="grid ">
          <div className="w-full p-2 text-lg duration-100 cursor-pointer
          text-card dark:text-card_dark
          hover:bg-slate-300 dark:hover:bg-sky-900
          rounded-lg font-medium flex gap-2 items-center
          justify-between"
            onClick={() => onMenuClick(index)}>
            <div className="flex gap-2 items-center ">
              {props.icon}
              {props.label}
            </div>
            <div className="flex">
              {active ? <FaChevronUp /> : <FaChevronDown />}
            </div>
          </div>
          {
            <div className={classNames(
              "ml-6 grid",
              {
                "max-h-[1000px] overflow-hidden": active,
                "max-h-0 overflow-hidden ": !active,
                "animate-slide_down": active && changeTabRef.current,
                "animate-slide_up": !active && changeTabRef.current && prev_active,
              }
            )
            }>
              <SubMenu items={props.items} index={index} />
            </div>
          }
        </div>
      )
    else
      return (
        <NavLink to={props.to}>
          <div className={`w-full p-2 text-lg duration-100 cursor-pointer
          text-card dark:text-card_dark
          hover:bg-slate-300 dark:hover:bg-sky-900 rounded-lg 
          ${active_route ? 'font-bold text-sky-800 dark:text-pague_verde' : 'font-medium'} 
          flex gap-2 items-center`}
            onClick={() => onMenuClick(index)}>
            {props.icon}
            {props.label}
          </div>
        </NavLink>
      )
  }

  function SubMenu({ items, index }) {
    return (
      <React.Fragment key={index}>
        {
          items.map((item, index2) => {
            const new_index = String(index) + String(index2)
            //console.log(activeIndex,item.to,new_index)
            return (
              <MenuComponent props={item} index={new_index} key={new_index} />
            )
          })
        }
      </React.Fragment>
    )
  }

  return (
    <AppCard className="w-full h-full overflow-y-auto">
      <div className="flex flex-col">
        <span className="text-black">{userInfo.usuario_nome}</span>
        <SubMenu items={menuProviderModel[0].items} index="0" />
      </div>
    </AppCard>
  )
}